export const DEFAULT_END_DATE = new Date('2099/12/31');
